import React, {useEffect, useState} from "react";
import { ThemeProvider, Typography, Modal } from '@mui/material';
import SimpleBar from 'simplebar-react';

import {ThemeMain, ThemeCustom} from '../../styles/Theme';

import ButtonMain from "../button/Button_main";
import './Modal_style.scss'
import 'simplebar-react/dist/simplebar.min.css';

const summaryObj = {'name':'Alia Wiseman', 'description':'Knowledge of coding languages (e.g. C++, Java, JavaScript) and frameworks/systems (e.g. AngularJS, Git). Ability to learn new languages and technologies'
}

const ModalApplicantSummary = (props) => {

    const [detailedView, setDetailedView] = useState(false)

    //expand and collapse

    const detailedViewHandle = () => {
        setDetailedView(!detailedView)
    }

    useEffect(()=>{console.log('detailedView', detailedView, props.summaryBreakdown)},[detailedView])


    useEffect(()=>{
        console.log('props ', props.summaryBreakdown)
    },[props])

    return(
            <Modal
                open={props.openSummary}
               // onClose={()=>props.setOpenJobView(false)}
                aria-labelledby="modal-modal-title"
            >
                <div className="modal-container modal-view modal-max-h-80">
                    <Typography id="modal-modal-title" variant="textheader3" className="mb-2-modal" component="div">
                        Summary
                    </Typography>
                    <Typography id="modal-modal-title"  className="mb-3-modal" variant="textBaseLight" component="div">
                       Applicant Name : <span className="modal-text-primary">{props.applicant ? props.applicant.name : '-'}</span> 
                       {props.rating ? (
                       <>                       
                            <span className="px-2-modal">|</span> 
                            Match : <span className="modal-text-primary">{props.rating ? props.rating : '-'}</span> 
                            {/* Match : <span className={`${props.rating > 79 ? 'modal-text-green' : props.rating > 64 ? 'modal-text-yellowSun'  : props.rating > 45 ? 'modal-text-orange' : 'modal-text-red'} modal-font-semibold`}>{props.rating}</span> */}
                       </>
                    ):''}
                    </Typography>
                    <Typography id="modal-modal-title" variant="textBaseLight" component="div">
                        Email : <span className="modal-text-primary">{props.applicant ? (<a href={`mailTo:${props.applicant.email}`}>{props.applicant.email}</a>) : '-'}</span> 
                        <span className="px-2-modal">|</span> 
                        Phone : <span className="modal-text-primary">{props.applicant ? (<a href={`tel:${props.applicant.phoneNo}`}>{props.applicant.phoneNo}</a>) : '-'}</span> 
                    </Typography>
                    <div className="border-bottom-modal mb-5-modal"></div>
                    <Typography component={'div'} variant="textBase" className="mb-5-modal">
                        <SimpleBar className="scroll-discription">
                            {props.summaryDiscription}
                        </SimpleBar>
                    </Typography>
                    <div className="mb-5-modal ">
                        {props.summaryBreakdown ? (
                            <div className="flex justify-between items-center job-view-Detailed-container">
                                <Typography component={'div'} variant="textheader3" className="mb-5-modal summary-detailed-view">
                                Detailed View
                                </Typography>
                                {props.summaryBreakdown ? (
                                    <Typography component={'div'} variant="textBase" className="mb-2-modal expandHandle" onClick={()=>detailedViewHandle()}>
                                        {detailedView ? 'Collapse' : 'Expand'}
                                    </Typography>
                                ):''}
                            </div>
                        ):''}
                    <SimpleBar className={`scroll-detailed-view ${detailedView ? 'collapse' : 'expand'}`}>
                    {props.summaryBreakdown && props.summaryBreakdown.map((item, index)=>(
                        <div key={index} className="mb-2-modal">
                            {item  &&  Object.entries(item).map(([key, value], index)=>(
                                <React.Fragment key={index}>
                                    <Typography component={'div'} variant="textBase" className="mb-2-modal summary-requirement">
                                        {key}: 
                                    </Typography>
                                    <div>
                                        <Typography component={'div'} variant="textBase" className="mb-1-modal summary-rate">
                                            {value.rating} of {value.weight}
                                        </Typography>
                                        <Typography component={'div'} variant="textBase" className="mb-2-modal summary-reason">
                                            {value.reason}
                                        </Typography>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    ))}
                    </SimpleBar>
                    </div>
                    <div className="modal-footer-right mt-5-modal pt-5-modal border-top-modal">
                        <ButtonMain 
                            variant='primaryOutline' 
                            type='button' 
                            disabled={false} 
                            name='Cancel'
                            class='modal-capitalize'
                            onClick={()=> {props.setOpenSummary(false); setDetailedView(false)}}
                        />
                    </div>
                </div>
            </Modal>
    )
}

export default ModalApplicantSummary;